import { formatMoney } from '@archetype-themes/scripts/helpers/currency'

document.addEventListener('DOMContentLoaded', initializeEventListeners);
const MAX_SIZE_VARIANTS = 7

function initializeEventListeners() {
    // Set swatch event listeners
    const swatches = document.querySelectorAll('.collection-grid__wrapper .swatch-color-boa');
    swatches.forEach((swatch) => {
        swatch.addEventListener('click', handleColorSwatchChange, true);
    });

    // Set toggle swatch event listeners
    const plusIcons = document.querySelectorAll('.extend-swatch-options');
    plusIcons.forEach(swatch => {
        swatch.addEventListener('click', toggleSwatchColors);
    });

    // Set up quick-shop event listener
    document.addEventListener("quickshop:opened", function () {
        const tooltip = document.querySelector(".tool-tip__inner");
        const colorSwatches = tooltip.querySelectorAll('.swatch-color-boa');
        colorSwatches.forEach(swatch => {
            swatch.addEventListener('click', redirectProductPage);
        });
    });
}

function handleColorSwatchChange(e) {
    e.preventDefault();
  
    const swatch = e.target;
    const swatchClickedColor = swatch.style.getPropertyValue('--product-current-color');
    const swatchClickedColorId = swatch.dataset.productId;
    const swatchCurrentColor = e.target.closest('.swatch-colors-wrapper').querySelector('.current-product-color').style.getPropertyValue('--product-current-color');
    const swatchCurrentColorId = e.target.closest('.swatch-colors-wrapper').querySelector('.current-product-color').dataset.productId;

    if(swatchCurrentColor === swatchClickedColor && swatchClickedColorId === swatchCurrentColorId) {
        return;
    }
  
    const productId = swatch.closest('.product-grid-item').dataset.productSwatchId;
    const productBlock = document.querySelector(
		`.collection-grid__wrapper .grid-item .product-grid-item[data-product-swatch-id="${productId}"]`
	);
    
    updateProductImage(productBlock, swatch);
    updateProductPrice(productBlock, swatch);
    updateProductTitle(productBlock, swatch);
    updateProductColorName(productBlock, swatch);
    updateProductUrl(productBlock, swatch);
    updateSelectedColor(productBlock, swatch);
    updateDiscountText(productBlock, swatch);
    updateSoldOutTag(productBlock, swatch);
    updateExtraTag(productBlock, swatch);
    updateCustomTag(productBlock, swatch);
    updateQuickAddButton(productBlock, swatch);
    updateQuickShopButton(productBlock, swatch);
    updateSizesAvailability(productBlock, swatch);

    const isProductBundlePage = window.location.href;
    if (isProductBundlePage.includes('/products')){
        updateQuantitySelectorProductVariant(productBlock, swatch);
    }
}

function updateProductImage(productBlock, swatch) {
    const productImageElement = productBlock.querySelector('.grid__image-ratio img');
    const newImageUrl = swatch.dataset.productImage;

    if (productImageElement && newImageUrl) {
        productImageElement.srcset = newImageUrl;
    }
}

function updateProductPrice(productBlock, swatch) {
    const isProductFromProductPage = productBlock.querySelector('.grid-product__price');
    if(isProductFromProductPage.classList.contains('required')) {
        return;
    }
    const currentPriceContainer = productBlock.querySelector('.grid-product__price');
    const comparePrice = currentPriceContainer.querySelector('.grid-product__price--original');
    const selectedCompare = removeCommas(swatch.dataset.productComparePrice);
    const price = removeCommas(swatch.dataset.productPrice);
    if (Number(selectedCompare > 0)) {
        changePriceCompare({
            comparePrice,
            price,
            selectedCompare,
            currentPriceContainer
        });
    } else {
        changePriceOriginal(comparePrice, currentPriceContainer);
    }
    updatePriceWithoutCompare(currentPriceContainer, price);
}

function changePriceCompare({
    comparePrice,
    price,
    selectedCompare,
    currentPriceContainer
}) {
    if(comparePrice) {
        // Currency format: " ₪"
        // Using "{"+"{"+'amount'+"}"+"}" + " ₪" to avoid Liquid processing
        const formattedComparePrice = formatMoney(selectedCompare, "{"+"{"+'amount'+"}"+"}"+  " ₪", true); 
        const modifiedPrice = formattedComparePrice.replace('</sup> ₪', ' ₪</sup>')
        const fullNumber = comparePrice.querySelector('span[aria-hidden="true"]');
        fullNumber.innerHTML = modifiedPrice;
    } else {
        createComparePrice({comparePrice, price, selectedCompare, currentPriceContainer});
    }
}

function changePriceOriginal(comparePrice) {
    if (!comparePrice) {
        return;
    }
    comparePrice.remove();
}

function updatePriceWithoutCompare(currentPriceContainer, currentPrice) {
    const priceElement = currentPriceContainer.querySelector('.grid-product__price--current span[aria-hidden="true"]');
    if (!priceElement) {
        return;
    }
    const formattedPrice = formatMoney(currentPrice, "{"+"{"+'amount'+"}"+"}" + " ₪", true); 
    const modifiedPrice = formattedPrice.replace('</sup> ₪', ' ₪</sup>')
    priceElement.innerHTML = modifiedPrice;
}

function createComparePrice({
    selectedCompare, 
    currentPriceContainer
}) {
    const formattedComparePrice = formatMoney(selectedCompare, "{"+"{"+'amount'+"}"+"}" + " ₪", true); 
    const modifiedPrice = formattedComparePrice.replace('</sup> ₪', ' ₪</sup>')
    const comparePriceSpan = document.createElement('span');
    const innerSpan = document.createElement('span');
    comparePriceSpan.classList.add('grid-product__price--original');
    innerSpan.setAttribute('aria-hidden', 'true');
    innerSpan.innerHTML = modifiedPrice; 
    comparePriceSpan.appendChild(innerSpan);
    currentPriceContainer.appendChild(comparePriceSpan);
}

function removeCommas(price) {
    const cleanedPriceString = price.replace(/,/g, '');
    const number = parseFloat(cleanedPriceString);
    return number.toFixed(2);
}

function updateProductTitle(productBlock, swatch) {
    const title = productBlock.querySelector('.grid-product__title');
    const newTitle = swatch.dataset.productTitle;
    if (title) {
        title.textContent = newTitle;
    }
}

function updateProductColorName(productBlock, swatch) {
    const colorName = productBlock.querySelector('.current-color-name');
    const newColorName = swatch.dataset.productColor;
    if (colorName) {
        const span = colorName.querySelector('span');
        span.textContent = newColorName;
    }
}

function updateDiscountText(productBlock, swatch) {
    const existingProductDiscount = productBlock.querySelector('.boa-discount-text');
    const newProductDiscountText = swatch.dataset.productDiscountText;
   
    if (!existingProductDiscount && !newProductDiscountText) {
        return;
    }
    if (existingProductDiscount) {
        existingProductDiscount.textContent = newProductDiscountText
    }
    if (newProductDiscountText && !existingProductDiscount) {
        const targetElement = productBlock.querySelector('.grid-item__content'); 
        const discountDiv = document.createElement('div');
        discountDiv.classList.add('boa-discount-text');
        discountDiv.textContent = newProductDiscountText;
        targetElement.appendChild(discountDiv);
    } 
}

function updateSoldOutTag(productBlock, swatch) {
    const tagsContainer = productBlock.querySelector('.grid-product__tags');
    const existingSoldOutTag = tagsContainer.querySelector('.grid-product__tag--sold-out');
    const productAvailable = swatch.dataset.productAvailable;

    if (!existingSoldOutTag && productAvailable === 'true') {
        return;
    }

    if (existingSoldOutTag && productAvailable === 'true') {
        existingSoldOutTag.remove();
    }

    if (!existingSoldOutTag && productAvailable === 'false') {
        const tagDiv = document.createElement('div');
        tagDiv.textContent =  "אזל המלאי";
        tagDiv.classList.add('grid-product__tag', 'grid-product__tag--sold-out');
        tagsContainer.appendChild(tagDiv);
    }
}

function updateExtraTag(productBlock, swatch) {
    const tagsContainer = productBlock.querySelector('.grid-product__tags');
    const extraTag = tagsContainer.querySelector('.extra-tag');
    const existingExtraTag = swatch.dataset.productExtraTag;

    if (!existingExtraTag.trim() && !extraTag ) {
        return;
    }
    if (existingExtraTag && !extraTag) {
        const tagDiv = document.createElement('div');
        tagDiv.classList.add('extra-tag');
        tagDiv.textContent = existingExtraTag;
        tagsContainer.appendChild(tagDiv);
    }
    if (!existingExtraTag && extraTag) {
        extraTag.remove();
    }
}

function updateCustomTag(productBlock, swatch) {
    const tagsContainer = productBlock.querySelector('.grid-product__tags');
    const customTag = tagsContainer.querySelector('.grid-product__tag.grid-product__tag--custom');
    const existingCustomTag = swatch.dataset.productCustomTag;

    if (!existingCustomTag.trim() && !customTag ) {
        return;
    }
    if (existingCustomTag && !customTag) {
        const tagDiv = document.createElement('div');
        tagDiv.classList.add('grid-product__tag', 'grid-product__tag--custom');
        tagDiv.textContent = existingCustomTag;
        tagsContainer.appendChild(tagDiv);
    }
    if (!existingCustomTag && customTag) {
        customTag.remove();
    }
}

function updateProductUrl(productBlock, swatch) {
    const url = productBlock.querySelector('.grid-item__link');
    const newUrl = swatch.dataset.productHandle;
    if (url) {
        url.href = `${window.location.origin}/products/${newUrl}`;
    }
}

function updateSelectedColor(productBlock, swatch) {
    const currentColor = productBlock.querySelector('.swatch-color-boa.current-product-color');
    if (currentColor) {
        currentColor.classList.remove('current-product-color');
        swatch.classList.add('current-product-color');
    }
}

function updateQuickAddButton(productBlock, swatch) {
    const quickAddButton = productBlock.querySelector('.quick-add-btn');
    if (!quickAddButton){
        return;
    }
    const isOutOfStock = quickAddButton.classList.contains('out-of-stock');
    const isNewVariantAvailable = swatch.dataset.productAvailable === 'true';

    if (isOutOfStock && isNewVariantAvailable) {
        quickAddButton.classList.remove('out-of-stock');
    }
     if (!isOutOfStock && !isNewVariantAvailable) {
        quickAddButton.classList.add('out-of-stock');
    }
    quickAddButton.setAttribute("data-id", swatch.dataset.key);
}

function updateQuickShopButton(productBlock, swatch) {
    const button = productBlock.querySelector('.quick-product__btn');
    const currentProductId = productBlock.dataset.productId;
    if (button) {
        button.classList.remove(`js-modal-open-quick-modal-${currentProductId}`)
        button.setAttribute("data-handle", swatch.dataset.productHandle);
        button.classList.add(`js-modal-open-quick-modal-${swatch.dataset.productId}`);
        productBlock.setAttribute('data-product-handle', swatch.dataset.productHandle);
        productBlock.setAttribute('data-product-id', swatch.dataset.productId);
    }
}

function updateSizesAvailability(productBlock, swatch) {
    const productItemSizeContainer = productBlock.querySelector('.product-item-sizes-popup');
    if (!productItemSizeContainer) {
        return;
    }
    const productItemSizeWrapper = productItemSizeContainer.querySelector('.product-item-sizes-wrap');
    const sizesAvailability = swatch.dataset.productSizesAvailability.split(',');
    const sizeItems = productItemSizeWrapper.querySelectorAll('.size-item');
    const existingSizesCount = sizeItems.length;
    const newSizesCount = sizesAvailability.length;

    productItemSizeWrapper.textContent = '';
    sizesAvailability.forEach(sizeData => {
       const [size, availability] = sizeData.split(':');
       if (!size.trim() || !availability.trim()) {
        return;
       }
       const sizeItem = document.createElement('p');
       sizeItem.classList.add('size-item');
       sizeItem.textContent = size.trim();
       if (availability.toLowerCase() === "false") {
            sizeItem.classList.add('size-unavailable');
       }
       productItemSizeWrapper.appendChild(sizeItem);
    });
    const arrowDown = productItemSizeContainer.querySelector('.arrow-btn-down');
    const arrowUp = productItemSizeContainer.querySelector('.arrow-btn-up');
    if (existingSizesCount < MAX_SIZE_VARIANTS && newSizesCount > MAX_SIZE_VARIANTS ) {
        arrowDown.classList.remove('hidden-arrow');
        productItemSizeContainer.dataset.sizesAmount = newSizesCount;        
    } 
    if (existingSizesCount > MAX_SIZE_VARIANTS && newSizesCount < MAX_SIZE_VARIANTS ) {
        arrowDown.classList.add('hidden-arrow');
        arrowUp.classList.add('hidden-arrow');
        productItemSizeContainer.dataset.sizesAmount = newSizesCount;
        productItemSizeContainer.dataset.currentPage = 1;
        const wrapper = productItemSizeContainer.querySelector('.product-item-sizes-wrap');
        wrapper.style.transform = `translateY(0)`;
    }
    productItemSizeWrapper.addEventListener('change', (e) => handleScrollSizes(e));
}

function toggleSwatchColors(e) {
    e.preventDefault();
    const button = e.target.closest('.extend-swatch-options');
    const swatchWrapper = button.closest('.swatch-colors-wrapper');
    const hiddenSwatches = swatchWrapper.querySelectorAll('.swatch-color-boa:nth-child(n+5)');

    button.classList.toggle('active');

    hiddenSwatches.forEach(swatch => {
        if (button.classList.contains('active')) {
            swatch.classList.remove('hidden-swatch');
        } else {
            swatch.classList.add('hidden-swatch');
        }
    });
    // Moves button to the end after expansion
    if (button.classList.contains('active')) {
        swatchWrapper.appendChild(button);
    }
}

function redirectProductPage(e) {
    window.location.href = e.target.dataset.productUrl;
}

function updateQuantitySelectorProductVariant(productBlock, swatch) {
    const quantitySelectorInput = productBlock.querySelector('.quantity-selector__input');
    const newVariantId = swatch.dataset.key;
    if (!quantitySelectorInput) {
        return;
    }
    quantitySelectorInput.dataset.productVariantId = newVariantId;
    quantitySelectorInput.setAttribute('name', `quantity-${newVariantId}`);
}